<template>
  <div class="productcenter1html">
    <div class="productcenter1head">
      <div class="productcenter1headtext">
        <p
          style="
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 24px;
          "
        >
          套利交易
        </p>
        <p
          style="
            font-size: 15px;
            color: #000000;
            line-height: 20px;
            letter-spacing: 1px;
          "
        >
          支持内外盘套利交易以及自由配比的套利合约交易，多种算法交易防止瘸腿，一键完成套利下单，像单个合约下单一样方便。
        </p>
      </div>
    </div>
    <div class="productcenter1body">
      <div class="productcenter1bodytag">
        <ul style="padding-top: 70px">
          <li class="pli">
            <div v-bind:class="[form.oneth ? class4 : class3]"></div>
            <div v-bind:class="[form.oneth ? class1 : class5]" @click="oneth">
              <div style="width: 45px; height: 42px; float: left"></div>
              <div class="tagmid" style="width: 165px">
                套利k线图技术分析
              </div>
              <div style="width: 5px; height: 40px; float: left"></div>
            </div>
          </li>

          <li class="pli">
            <div v-bind:class="[form.seventh ? class4 : class3]"></div>
            <div
              v-bind:class="[form.seventh ? class1 : class2]"
              @click="seventh"
            >
              <div style="width: 45px; height: 42px; float: left"></div>
              <div class="tagmid">价差分析</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.oneth"
            >
              <img
                src="../../assets/images/huang-jia.png"
                style="display: block"
              />
            </div>
          </li>

          <li class="pli">
            <div v-bind:class="[form.nineth ? class4 : class3]"></div>
            <div v-bind:class="[form.nineth ? class1 : class2]" @click="nineth">
              <div style="width: 45px; height: 42px; float: left"></div>
              <div class="tagmid">独立的套利下单界面</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.seventh"
            >
              <img
                src="../../assets/images/huang-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <!-- <li class="pli">
            <div v-bind:class="[form.tenth ? class4 : class3]"></div>
            <div v-bind:class="[form.tenth ? class1 : class2]" @click="tenth">
              <div style="width: 45px; height: 42px; float: left"></div>
              <div class="tagmid">套利条件单</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.nineth"
            >
              <img
                src="../../assets/images/huang-jia.png"
                style="display: block"
              />
            </div>
          </li> -->
          <li class="pli">
            <div v-bind:class="[form.eleventh ? class4 : class3]"></div>
            <div
              v-bind:class="[form.eleventh ? class1 : class6]"
              @click="eleventh"
            >
              <div style="width: 45px; height: 42px; float: left"></div>
              <div class="tagmid">常见问题解答</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
            <div
              style="width: 9px; height: 7px; float: left; ine-height: 7px"
              v-if="form.nineth"
            >
              <img
                src="../../assets/images/huang-jia.png"
                style="display: block"
              />
            </div>
          </li>
          <li class="pli">
            <div
              style="width: 10px; height: 7px; float: right; ine-height: 7px"
              v-if="form.eleventh"
            >
              <img
                src="../../assets/images/huang-jia.png"
                style="display: block"
              />
            </div>
          </li>
        </ul>
      </div>
      <div style="height: 18px"></div>
      <div class="productcenter1bodytext" ref="box">
        <div style="width: 780px; border-radius: 2%; position: relative">
          <div class="midtext">
            <div v-if="form.oneth">
              <h4 class="head4" id="one">一、套利k线图技术分析</h4>
              <p class="pproduct">
                提示：自定义套利合约修改参数后，两天后才可看到新的K线图。
              </p>
              <p class="pproduct">
                设置套利合约对后，可以查看套利K线图。套利k线图与单合约一致，支持加载技术分析指标，做套利像做单合约一样方便。
              </p>
              <p class="pproduct">
                下图是自设套利合约塑料2001—PP2001的日K线图，除提供K线图外，软件还提供盘口报价及副图指标。
              </p>
              <p class="pimg"><img src="@/../public/proimg1/t-1.gif" /></p>
              <p class="pproduct">
                当我们需要做技术分析时，通过选择鼠标右键中的【叠加技术指标】即可在K线图上增加分析指标或切换副图指标。
              </p>
              <p class="pimg"><img src="@/../public/proimg1/t-2.gif" /></p>
            </div>
            <div v-if="form.seventh">
              <h4 class="head4" id="seven">二、价差分析</h4>
              <p class="pproduct">
                软件提供专业的价差分析工具，在套利合约系统K线图上单击鼠标右键可调出价差分析图，如下图所示。
              </p>
              <p class="pimg"><img src="@/../public/proimg1/t-a2.jpg" /></p>
              <p class="pproduct">
                下图为价差周期性图、二腿价格走势百分比图、二腿相关度、价差分布图以及二腿价格走势图展示。
              </p>
              <p class="pimg" ><img src="@/../public/proimg1/t-tu.png" /></p>
              <!-- <div v-if="show1">
                <p class="pimg"><img src="@/../public/proimg1/t-tu2.png" /></p>
              </div>
              <p @click="show1=!show1" style="width:643px;cursor:pointer;color:blue;margin:0px auto 15px auto;font-size:15px;">{{show1?"点击收起":"展开查看更多例图"}}</p> -->
              <p class="pproduct">
                软件还提供了价差矩阵，用于跨期套利的升贴水分析，在右上角菜单【套利】->价差矩阵，选择市场和品种设置即可，如下图。
              </p>
              <p class="pimg"><img src="@/../public/proimg1/t-b2.gif" /></p>
            </div>
            <div v-if="form.nineth">
              <h4 class="head4" id="nine">三、独立的套利下单界面</h4>
              <p class="pproduct">
                下图为套利专用下单界面，交易员可对套利合约设置价差判断，添加下单任务到后台运行，由软件实时监控价差变动，符合价差条件时自动下单，轻松实现套利交易。
              </p>
              <p class="pimg"><img src="@/../public/proimg1/TLXD-1.jpg" /></p>
              <h5 class="head5">1、套利开仓</h5>
              <p class="pproduct">如下图，是设置套利开仓任务的操作方法：</p>
              <p class="pimg"><img src="@/../public/proimg1/TLXD-2.jpg" /></p>
              <h5 class="head5">2、套利平仓</h5>
              <p class="pproduct">
                方法1：在【配对持仓】中选择要平仓的套利持仓，添加平仓下单任务；
              </p>
              <p class="pproduct">
                方法2：在【配对持仓】列表中选中持仓，右键平仓，此方式可立即平仓；
              </p>
              <p class="pimg"><img src="@/../public/proimg1/TLXD-3.jpg" /></p>
              <h5 class="head5">3、套利撤单</h5>
              <p class="pproduct">
                未成交的委托可以执行撤单操作。如下图，点击撤单和清理未配对持仓执行相应的撤单操作。
              </p>
              <p class="pimg"><img src="@/../public/proimg1/t-14.gif" /></p>
              <p class="pproduct">注：</p>
              <p class="pproduct">
                1、“撤单”是指立即终止这次的套利交易行为，将未成交的委托撤单，但是在点这个按钮之前的成交合约保留。
              </p>
              <p class="pproduct">
                2、点击“撤单”再点击“清理未配对持仓”，是指立即终止这次的套利交易行为，但是在点这个按钮之前已经完成配对的套利对保留，并自动撤掉挂单，并平掉没有配对的持仓。
              </p>
            </div>
            <!-- <div v-if="form.tenth">
              <h4 class="head4" id="ten">四、套利条件单</h4>
              <p class="pproduct">
                在套利合约对下单界面，按照如下图所示的步骤设置套利条件单；会自动生成套利条件单，并显示在上方套利条件单栏中。
              </p>
              <p class="pimg"><img src="@/../public/proimg1/t-15.gif" /></p>
              <p class="pproduct">注：</p>
              <p class="pproduct">
                1、条件单只有在软件正常运行状态下才能触发，交易账户退出、网络中断等情况条件单无效。
              </p>
              <p class="pproduct">
                2、设置成功的条件单在套利下单界面的套利表达式中可以看到条件单标记。
              </p>
            </div> -->
            <div v-if="form.eleventh">
              <h4 class="head4" id="eleven">四、常见问题解答</h4>
              <h5 class="head5">1、套利图是否支持加载自编指标？</h5>
              <p class="pro">
                答：支持。在k线图上单击鼠标右键->技术指标，找到您已经编好的指标名，点击后会自动加载到图上。
              </p>
              <h5 class="head5" id="qs3">
                2、如何通过流动性级别控制委托顺序，避免瘸腿？
              </h5>
              <p class="pro">
                答:如下图，在交易参数设置里设置流动性级别，设置好后，会先委托流动性级别低的合约，成交后，再委托流动性级别高的合约，这样可以最大限度避免瘸腿问题。
              </p>
              <p class="pimg"><img src="@/../public/proimg1/TLXD-6.jpg" /></p>
              <h5 class="head5">
                3、交易设置界面的"下单份数"是什么意思，是下单手数的意思吗？
              </h5>
              <p class="pro">
                答：套利下单界面的“份数”和手数不是一个意思。
              </p>
              <p class="ppro">我们在配置套利对的时候可以设置每个合约的交易手数，如，玉米2405-豆油2405，玉米设置的下单手数是2，豆油设置的下单手数是1；</p>
              <p class="ppro">那么当下单份数是1份的时候会委托2手玉米和1手豆油；下单份数是2份的时候，会委托4手玉米和2手豆油。</p>
              <h5 class="head5" id="qs5">
                4、套利合约单腿不成交可以自动撤单吗？
              </h5>
              <p class="pro">
                答：可以。自设套利合约下单时，可启用撤单算法，由软件自动监控挂单时长和价差偏离值，达到条件自动撤单，有效控制成交滑点。
              </p>
              <p class="pimg"><img src="@/../public/proimg1/TLXD-5.jpg" /></p>
              <p class="pproduct">注：</p>
              <p class="pproduct">
                1、辅助算法自动撤单后，下单任务不会终止，当价差满足条件会再次委托，直到下单份数全部成交（自动追市价算法除外）；
              </p>
              <p class="pproduct">
                2、套利下单任务的撤单算法触发后不会进行清理未配对操作，若产生瘸腿，需手动清理未配对持仓；
              </p>
              <h5 class="head5">
                5、套利持仓右键的套利配对是什么意思，要怎么用？
              </h5>
              <p class="pro">
                答：套利配对可以把手动开仓的合约合并成套利对或者分开套利持仓。
              </p>
              <p class="pro">
                在套利持仓中点中要配对的套利对，单击鼠标右键选择【套利持仓配对】按钮。在弹出的窗口中点【生成配对】会自动把单合约持仓合并成套利对持仓，点【删除配对持仓】会自动把生成的套利对持仓分开。如下图所示，是如何进行套利配对操作。
              </p>
              <p class="pimg"><img src="@/../public/proimg1/TLXD-10.jpg" /></p>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        oneth: true,
        twoth: false,
        threeth: false,
        fourth: false,
        fiveth: false,
        sixth: false,
        seventh: false,
        eighth: false,
        nineth: false,
        tenth: false,
        eleventh: false,
      },
      show1:false,
      class1: "onclick",
      class2: "noclick",
      class3: "touming",
      class4: "yellow",
      class5: "noclickone",
      class6: "noclickele",
    };
  },
  methods: {
    custormAnchor(anchorName) {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });

      this.form[anchorName + "th"] = true;
    },
    oneth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.oneth = true;
      var id = "one";
      this.$router.push({ path: `/proc/productcenter1/${id}` });
      this.custormAnchor(id);
    },
    twoth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.twoth = true;
      var id = "two";
      this.$router.push({ path: `/proc/productcenter1/${id}` });
      this.custormAnchor(id);
    },
    threeth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.threeth = true;
      var id = "three";
      this.$router.push({ path: `/proc/productcenter1/${id}` });
      this.custormAnchor(id);
    },
    fourth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.fourth = true;
      var id = "four";
      this.$router.push({ path: `/proc/productcenter1/${id}` });
      this.custormAnchor(id);
    },
    fiveth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.fiveth = true;
      var id = "five";
      this.$router.push({ path: `/proc/productcenter1/${id}` });
      this.custormAnchor(id);
    },
    sixth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.sixth = true;
      var id = "six";
      this.$router.push({ path: `/proc/productcenter1/${id}` });
      this.custormAnchor(id);
    },
    seventh() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.seventh = true;
      var id = "seven";
      this.$router.push({ path: `/proc/productcenter1/${id}` });
      this.custormAnchor(id);
    },
    eighth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.eighth = true;
      var id = "eight";
      this.$router.push({ path: `/proc/productcenter1/${id}` });
      this.custormAnchor(id);
    },
    nineth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.nineth = true;
      var id = "nine";
      this.$router.push({ path: `/proc/productcenter1/${id}` });
      this.custormAnchor(id);
    },
    tenth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.tenth = true;
      var id = "ten";
      this.$router.push({ path: `/proc/productcenter1/${id}` });
      this.custormAnchor(id);
    },
    eleventh() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.eleventh = true;
      var id = "eleven";
      this.$router.push({ path: `/proc/productcenter1/${id}` });
      this.custormAnchor(id);
    },
    zero() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
    },
    menu(e) {
      if (
        e.target.scrollTop >= document.querySelector("#one").offsetTop &&
        document.querySelector("#two").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.oneth = true;
        var id1 = "one";
        this.$router.push({ path: `/proc/productcenter1/${id1}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#two").offsetTop &&
        document.querySelector("#three").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.twoth = true;
        var id2 = "two";
        this.$router.push({ path: `/proc/productcenter1/${id2}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#three").offsetTop &&
        document.querySelector("#four").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.threeth = true;
        var id3 = "three";
        this.$router.push({ path: `/proc/productcenter1/${id3}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#four").offsetTop &&
        document.querySelector("#five").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.fourth = true;
        var id4 = "four";
        this.$router.push({ path: `/proc/productcenter1/${id4}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#five").offsetTop &&
        document.querySelector("#six").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.fiveth = true;
        var id5 = "five";
        this.$router.push({ path: `/proc/productcenter1/${id5}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#six").offsetTop &&
        document.querySelector("#seven").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.sixth = true;
        var id6 = "six";
        this.$router.push({ path: `/proc/productcenter1/${id6}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#seven").offsetTop &&
        document.querySelector("#eight").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.seventh = true;
        var id7 = "seven";
        this.$router.push({ path: `/proc/productcenter1/${id7}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#eight").offsetTop &&
        document.querySelector("#nine").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.eighth = true;
        var id8 = "eight";
        this.$router.push({ path: `/proc/productcenter1/${id8}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#nine").offsetTop &&
        document.querySelector("#ten").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.nineth = true;
        var id9 = "nine";
        this.$router.push({ path: `/proc/productcenter1/${id9}` });
      } else if (
        e.target.scrollTop >= document.querySelector("#ten").offsetTop &&
        document.querySelector("#eleven").offsetTop > e.target.scrollTop
      ) {
        this.zero();
        this.form.tenth = true;
        var id10 = "ten";
        this.$router.push({ path: `/proc/productcenter1/${id10}` });
      } else {
        this.zero();
        this.form.eleventh = true;
        var id11 = "eleven";
        this.$router.push({ path: `/proc/productcenter1/${id11}` });
      }
    },
  },
  mounted() {
    this.custormAnchor(this.$route.params.id);
  },
};
</script>

<style scoped>
.productcenter1html {
  background: url("../../assets/images/ts-bg_02.jpg") no-repeat top, #eef0ff;
  background-size: 100%;
  min-width: 1400px;
  width: 100%;
}
.productcenter1head {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.productcenter1headtext {
  position: absolute;
  top: 90px;
}
.productcenter1body {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.productcenter1bodytag {
  width: 570px;
  height: 560px;
  border-radius: 2%;
  background: url("../../assets/images/ts-2_01.png") no-repeat center;
  background-size: 100% 100%;
  position: absolute;
}
.productcenter1bodytext {
  margin-left: 220px;
  width: 780px;
  min-height: 680px;
  border-top-left-radius: 1em;
  background: url("../../assets/images/ts-2_02.jpg") no-repeat top #f7f7f7;
  background-size: 100%;
  overflow-x: hidden;
  filter: drop-shadow(1px 1px 2px #dee0f1);
}
.noclick {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #ebcb91;
  color: #69532b;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.onclick {
  height: 42px;
  line-height: 42px;
  background: #fdfdfd;

  width: 220px;
  letter-spacing: 1px;

  text-align: left;

  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;

  color: #4e2c2b;
}
.touming {
  width: 5px;
  height: 42px;
  float: left;
}
.yellow {
  width: 5px;
  height: 42px;
  background: #915c0e;
  float: left;
  border-top-left-radius: 0.1em;
  border-bottom-left-radius: 0.1em;
}
.head4 {
  color: #1a1c4b;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.midtext {
  margin: 0 auto;
  width: 680px;
  padding-bottom: 30px;
}
.pproduct {
  font-size: 15px;

  letter-spacing: 1px;
  color: #727983;
  line-height: 25px;
  /* width: 700px; */
  text-align: justify;
}
.pimg {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
.noclick:hover {
  color: #f59726;
}
.pli {
  width: 235px;
  height: 42px;
  margin-left: -5px;
  position: relative;
  z-index: 88;
}
.head5 {
  color: #1a1c4b;
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.ppro {
  font-size: 15px;
  letter-spacing: 1px;

  color: #727983;
  line-height: 25px;
  width: 670px;
  padding-left: 2em;
}
.pro {
  font-size: 15px;

  letter-spacing: 1px;
  color: #727983;
  line-height: 25px;
  width: 670px;
  text-indent: 2em;
}
.noclickone {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #ebcb91;
  color: #69532b;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickele {
  height: 40px;
  line-height: 40px;

  letter-spacing: 1px;
  width: 220px;
  border-bottom: 1px solid #ebcb91;
  border-top: 1px solid #ebcb91;
  color: #69532b;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickone:hover {
  color: #f59726;
}
.noclickele:hover {
  color: #f59726;
}
.tagmid {
  width: 140px;
  height: 42px;
  float: left;
  font-weight: bold;
}
</style>